import { Calculator, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLeadCapture } from '@/contexts/LeadCaptureContext';

export default function Hero() {
  const { openLeadForm } = useLeadCapture();

  return (
    <section className="relative overflow-hidden bg-brand-azul pt-24 pb-28 md:pt-32 md:pb-36">
      <div className="absolute -top-24 -right-24 w-[480px] h-[480px] rounded-full bg-brand-roxo/40 blur-3xl" aria-hidden />
      <div className="absolute -bottom-32 -left-24 w-[420px] h-[420px] rounded-full bg-brand-rosa/20 blur-3xl" aria-hidden />

      <div className="container px-4 mx-auto relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-4 py-1.5 text-xs font-semibold tracking-wider text-brand-rosa uppercase mb-6">
            I.A. de compras B2B
          </span>
          <h1 className="font-display text-4xl md:text-6xl font-extrabold text-white leading-[1.05] mb-6">
            Negocie. <span className="text-brand-rosa">Compre.</span> Escale.
          </h1>
          <p className="text-lg md:text-xl text-white/80 mb-4 max-w-2xl mx-auto leading-relaxed">
            A dgenny é a I.A. que cota, negocia e equaliza propostas com dezenas de fornecedores em paralelo —
            no WhatsApp, no seu ritmo, sem drama.
          </p>
          <p className="text-sm md:text-base text-brand-rosa font-semibold uppercase tracking-wider mb-10">
            O crescimento deixa de ser acaso e passa a ser escolha.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/calculadora-roi"
              className="px-7 py-3.5 bg-brand-rosa text-brand-azul font-bold rounded-full inline-flex items-center justify-center gap-2 hover:brightness-105 transition shadow-lg shadow-brand-rosa/20"
            >
              <Calculator size={18} /> Calcular meu ROI em 1 minuto
            </Link>
            <button
              onClick={() => openLeadForm({
                redirectToWhatsApp: true,
                whatsAppMessage: 'Olá! Quero entender como a dgenny pode reduzir minhas compras.',
              })}
              className="px-7 py-3.5 bg-white/10 border border-white/20 text-white font-semibold rounded-full hover:bg-white/15 transition inline-flex items-center justify-center gap-2 backdrop-blur"
            >
              <MessageCircle size={18} /> Tirar dúvidas
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
